module.exports = __webpack_public_path__ + "static/media/walkin.125e8dc8.svg";